'use strict';

const jQuery = require('jquery');
const _ = require('lodash');

require('jquery-ui/ui/widgets/autocomplete');
require('jquery-ui/ui/widgets/sortable');

const Translator = require('./../../../../core/translator');
const RequestHandler = require('./../../../../core/requestHandler');
const Autocomplete = require('./../../../autocomplete');
const Loader = require('./../../../loader');
const FormBuilder = require('./../../builder');

let ElementClass = require('./../../elementClass');
let itemDefaultTpl = require('./templates/item.hbs');
let itemFlagTpl = require('./templates/item_flag.hbs');

let itemConfigTpl = {
  default: itemDefaultTpl,
  flag: itemFlagTpl,
};

const getByUrl = function(url, data) {
  let result;

  url = (url.substring(0, 1) === '/') ? url.substring(1) : url;

  RequestHandler.setBaseUrl('');

  result = RequestHandler.read(url, data);

  RequestHandler.setBaseUrl('/rest/2');

  return result;
};

FormBuilder.register('searchList', function(config) {
  let self = {};
  let $itemWrapper;
  let renderType = config.renderType || 'normal';
  let termName = config.termName || 'term';
  let valueName = config.valueName || 'value';
  let labelName = config.labelName || 'label';
  let itemTpl = config.itemRenderType ? itemConfigTpl[config.itemRenderType] : itemConfigTpl.default;
  let maxEntry = config.maxEntry || 99;
  let $autocomplete;
  let $input;
  let disabledValue = config.disabled || false;

  let autocompleteConfig = {
    autocomplete: {
      'source': function(request, response) {
        let $element = config.form.$.find(`.element_${config.name}`);
        let $input = $element.find('.input-autocomplete');

        $input.find('span:first').addClass('invisible');

        Loader.start($input);
        getByUrl(config.url_request, {
          [termName]: request.term,
        }).done(function(data) {
          $input.find('span:first').removeClass('invisible');

          Loader.stop($input);
          response(data.filter((item) => {
            return $itemWrapper.find(`[data-id="${item.id}"]`).length === 0;
          }).map((item) => {
            let map = {
              label: item[labelName],
              value: item[valueName] || item.id || item.value,
              extra: item,
            };

            if (typeof config.onMap === 'function') {
              map = config.onMap(item);
            }

            if (typeof config.onItemSearch === 'function') {
              config.onItemSearch(map);
            }

            return map;
          }));
        });
      },
      'select': function(event, object) {
        jQuery(event.target).val('').blur();

        if (typeof config.onSelect === 'function') {
          config.onSelect(object.item);
        }

        if (config.addItemOnSelect !== false) {
          self.addItem(object.item);
        }

        return false;
      },
      'minLength': undefined === config.minLength ? (renderType === 'select' ? 0 : 3) : config.minLength,
    },
    icon: (renderType === 'select') ? 'sort-down' : null,
  };

  self = new ElementClass(config);

  const manageMaxEntry = () => {
    let currentLength = $itemWrapper.children('.item').length;

    if (typeof config.onListChange === 'function') {
      config.onListChange(currentLength);
    }

    $autocomplete[(currentLength >= maxEntry) ? 'addClass' : 'removeClass']('d-none');
  };

  self.addItem = function(data) {
    if (typeof config.onAddItem === 'function') {
      config.onAddItem(data);
    }

    let $item;

    if (typeof config.addItem === 'function') {
      $item = config.addItem(data);
    } else {
      $item = jQuery(itemTpl(data));
      let $remove = $item.find('button.remove');

      if (disabledValue === false) {
        $item.attr('data-id', data[valueName] || data.id || data.value);
        $remove.on('click', function() {
          if (typeof config.onRemoveItem === 'function') {
            config.onRemoveItem({
              value: $item.attr('data-id'),
              label: $item.find('.cloud-label').text(),
              item: data,
              $item,
            });
          }

          if (config.preventRemove !== true) {
            $item.remove();
            manageMaxEntry();
          }
        });
      } else {
        let $disableDiv = $item.find('.cloud-label').parent();
        $disableDiv.addClass('disabled');
        $remove.remove();
      }
    }

    $itemWrapper.append($item);
    manageMaxEntry();
  };

  self.render = function($wrap) {
    $autocomplete = Autocomplete.render(autocompleteConfig);
    $input = $autocomplete.find('input[name="autocomplete"]');

    if (disabledValue) {
      $input.attr('disabled', true);
    }

    if (config.placeholder) {
      $input.attr('placeholder', config.placeholder);
    }

    $wrap.addClass('cloud-menu-parameters');

    $itemWrapper = jQuery('<ul class="menu-item-wrapper  cloud-list list-unstyled"></ul>');

    $itemWrapper.sortable();

    _.forEach(config.value, function(item) {
      let map = {
        label: item[labelName],
        value: item[valueName] || item.id || item.value,
        extra: item,
      };

      if (typeof config.onMap === 'function') {
        map = config.onMap(item);
      }

      self.addItem(map);
    });

    if (renderType === 'select') {
      let $selectBtn = $input.next('span.autocomplete-search');

      $input.addClass('no-autofocus');
      $input.on('focus', function() {
        if ($input.hasClass('no-autofocus')) {
          $input.removeClass('no-autofocus');
          $input.blur();
        } else {
          $input.autocomplete('search', $input.val());
        }
      });

      $input.on('unfocus', function() {
        $input.autocomplete('close');
      });

      $selectBtn.on('click', function() {
        $input.autocomplete('search', $input.val());
      });
    }

    $wrap.append('<input type="text" class="d-none"/>');
    if (config.explanation || config.label) {
      $wrap.append('<label class="cloud-label">' + Translator.translate(config.explanation || config.label) || '' + '</label>');
    }
    $wrap.append($autocomplete);
    $wrap.append('<div class="cloud-divider"></div>');

    if (config.itemWrapperLabel) {
      $wrap.append(`<p>${Translator.translate(config.itemWrapperLabel)}</p>`);
    }

    $wrap.append($itemWrapper);

    return;
  };

  self.getData = function() {
    let data = [];

    $itemWrapper.find('.item').each(function() {
      let $current = jQuery(this);

      data.push({
        'id': $current.attr('data-id'),
        'label': $current.find('.cloud-label').text(),
      });
    });

    return data;
  };

  return self;
});
